import React, { FunctionComponent } from "react"
import { Table } from "react-bootstrap"
import RoleManagementTableHeader from "./RoleManagementTableHeader"
import RoleManagementTableBody from "./RoleManagementTableBody"
import "./RoleManagementTable.css"


const RoleManagementTable: FunctionComponent<{}> = () => {
    return (
        <div className="RoleManagementTable">
            <Table id="role-management-table" bordered hover>
                <RoleManagementTableHeader />
                <RoleManagementTableBody />
            </Table>
        </div>
    )
}

export default RoleManagementTable